/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/aces_secret_question_password_reset
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesSecretQuestionPasswordResetUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_secret_question_password_reset`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

export { postAcesSecretQuestionPasswordResetUtil };
